module.exports = __webpack_public_path__ + "static/media/blog9_sm.abef2755.webp";